/**
 * @generated SignedSource<<22ec7b7417994f59cc6ecd6ba8483894>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ModelDuplicateTargetInput = {
  imageUrl?: string | null;
  name: string;
  salesChannelId: string;
  sku: string;
};
export type testPageConnectModelMutation$variables = {
  id: string;
  replaceStandalone: boolean;
  target: ModelDuplicateTargetInput;
};
export type testPageConnectModelMutation$data = {
  readonly connectModel: string;
};
export type testPageConnectModelMutation = {
  response: testPageConnectModelMutation$data;
  variables: testPageConnectModelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "replaceStandalone"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "target"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "replaceStandalone",
        "variableName": "replaceStandalone"
      },
      {
        "kind": "Variable",
        "name": "target",
        "variableName": "target"
      }
    ],
    "kind": "ScalarField",
    "name": "connectModel",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "testPageConnectModelMutation",
    "selections": (v3/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v2/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "testPageConnectModelMutation",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "6172c532f2cbc1dc164a3f277753efcc",
    "id": null,
    "metadata": {},
    "name": "testPageConnectModelMutation",
    "operationKind": "mutation",
    "text": "mutation testPageConnectModelMutation(\n  $id: ID!\n  $target: ModelDuplicateTargetInput!\n  $replaceStandalone: Boolean!\n) {\n  connectModel(id: $id, target: $target, replaceStandalone: $replaceStandalone)\n}\n"
  }
};
})();

(node as any).hash = "7adc356698a6dbf09483b67565d25ad6";

export default node;
